function openCloseDynamicAccordionBlade(event) { 

    var elementParent = event.target.parentNode;
    var isOpen = elementParent.classList.contains('accordion__item--open');

    if (isOpen) {
        elementParent.classList.remove('accordion__item--open');
        elementParent.setAttribute('aria-expanded', 'false');
    } else {
        elementParent.classList.add('accordion__item--open');
        elementParent.setAttribute('aria-expanded', 'true');
    }
}

function calculateHeight() {
    document.querySelectorAll('.accordion__item').forEach(function (e) {
        var body = e.querySelector('.accordion__content');
        var height = e.offsetHeight + body.scrollHeight;

        e.style.maxHeight = height + 80 + "px";
    });
}

function applyClicks() {
    document.querySelectorAll('.accordion__title').forEach(function (r, index) {
        r.addEventListener('click', function (event) {

            event.preventDefault();
            openCloseDynamicAccordionBlade(event)

        }, false);
    });
}

applyClicks();